import React, { useContext } from 'react'
import { AppContext } from '../App'
import NavigationItemList from './NavigationItemList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

const iconAngleDown = <FontAwesomeIcon icon={ faAngleDown } size="sm" color="#00a8d5" />

export default function AppNavigation() {
   const { productOptionsSelected } = useContext(AppContext)
   const { productOptions } = productOptionsSelected
   const application = productOptions[1]
   const system = productOptions[2]
   // Create storage variables
   let navTitle, steps

   // If cove is selected, omit the "system type" step, as cove doesn't have a system type.
   const resinousSteps = system && system.toLowerCase('cove')==="cove" ? (
      [
         "Select Resinous Application",
         `Select ${ system } System`,
         "Provide Coverage Details"
      ]
   ) : (
      [
         "Select Resinous Application",
         `Select ${ system } System`,
         `Select ${ system } System Type`,
         "Provide Coverage Details"
      ]
   )
   
   const setNavTitleAndSteps = () => {
      return application.toLowerCase().indexOf('resinous') > -1 ? (
         navTitle = "Resinous Flooring",
         steps = resinousSteps
      ) : (
         application.toLowerCase().indexOf('adhesive') > -1 ? (
            navTitle = "Adhesives",
            steps = ["Choose an Adhesive", "Provide Coverage Details"]
         ) : (
            application.toLowerCase().indexOf('grout') > -1 ? (
               navTitle = "Grout",
               steps = ["Choose a Grout", "Provide Coverage Details"]
            ) : (
               application.toLowerCase().indexOf('underlayment') > -1 && (
                  navTitle = "Underlayments",
                  steps = ["Choose an Underlayment", "Provide Coverage Details"]
               )
            )
         )
      )
   }
   
   setNavTitleAndSteps()

   // // Determine which product type (application) was selected.
   // switch(application) {
   //    case "Resinous": navTitle = "Resinous Flooring"; steps = resinousSteps; break
   //    case "Adhesives": navTitle = "Adhesives"; steps = ["Choose an Adhesive", "Provide Coverage Details"]; break
   //    case "Grout": navTitle = "Grout"; steps = ["Choose a Grout", "Provide Coverage Details"]; break
   //    case "Underlayments": navTitle = "Underlayment"; steps = ["Choose an Underlayment", "Provide Coverage Details"]; break
   //    default: alert("No Product Option Found")
   // }
   
   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-3 col-md-pull-9 app-navigation-wrapper hidden-xs hidden-sm">
               <div className="app-navigation">
               {
                  // If Resinous Flooring was selected, render the "Select Application" nav item. This is not needed for Adhesives, Grout, and Underlayment product types.
                  productOptions[1]==="Resinous Flooring" && (
                     <NavigationItemList steps={ ["Select Application"] } title={ "Application" } />
                  )
               }
                  <NavigationItemList steps={ steps } title={ navTitle } />
               </div>
         </div>
         <div className="col-xs-12 col-md-3 col-md-pull-9 app-navigation-wrapper visible-xs visible-sm">
               <div className="panel-group" id="accordion" role="tablist">
                  <div className="panel panel-default">
                     <div className="panel-heading" role="tab" id="steps">
                           <h4>
                              <a role="button" className="collapsed" data-bs-toggle="collapse" href="#collapseStepsMobile" aria-expanded="true" aria-controls="steps">{ iconAngleDown } Steps</a>
                           </h4>
                     </div>
                     <div id="collapseStepsMobile" className="panel-collapse collapse" role="tabpanel" aria-labelledby="steps">
                           <div className="panel-body">
                              <div className="app-navigation">
                              {
                                 // If Resinous Flooring was selected, render the "Select Resinous Application" nav item. This is not needed for Adhesives, Grout, and Underlayment product types.
                                 productOptions[1]==="Resinous Flooring" && (
                                    <NavigationItemList steps={ ["Select Application"] } title={ "Application" } application={ application } />
                                 )
                              }
                                 <NavigationItemList steps={ steps } title={ navTitle } />
                              </div>
                           </div>
                     </div>
                  </div>
               </div>
         </div>
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/AppNavigation.js